// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__iduN-","productName":"Table_productName__27eat"};